import Countdown, { zeroPad } from "react-countdown";
import { useState } from "react";

const CodeExpiration = () => {
  const [countdown, setCountdown] = useState(Date.now() + 600000);
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <p>Code is expired. Login again to receive a new code.</p>;
    } else {
      // Render a countdown
      return (
        <span>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };
  return (
    <p style={{ textAlign: "center" }}>
      <Countdown date={countdown} renderer={renderer} />
    </p>
  );
};
export default CodeExpiration;
